<template>
  <div class="admin-lights">
    <div class="panelheader border-4">

      <div class="title">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/admin/clients'}">Clients Admin</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/admin/clients/' + clientId}">Sites Admin</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: `/admin/clients/${clientId}/site/${siteId}`}">Fields Admin</el-breadcrumb-item>
          <el-breadcrumb-item>{{pageName}}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      
      <div class="btn-wrapper">
        <el-button disabled type="add" @click="manualAdd">Manual Add</el-button>
      </div>

      <div class="btn-wrapper">
        <el-button type="add" @click="nodeScan" v-loading="nodeScanLoading" :disabled="nodeScanLoading">Scan for nodes</el-button>
      </div>

    </div>

      <changefieldmodal 
        :light="lightToChange"
        :show="showChangeFieldModal"
        :site="siteId"
        @closeModal="showChangeFieldModal = false"
        @update="updateLight"
        @new="newLight">
      </changefieldmodal>

      <div class="lights">
        <h2> {{ fieldName }} </h2>

          <el-table
            :data="lights"
            empty-text="No Lights Found"
            style="width: 100%">

            <el-table-column
              label="Number"
              prop="num"
              header-align="center">
            </el-table-column>

            <el-table-column 
              label="Nickname"
              prop="nickname"
              header-align="center">
            </el-table-column>

            <el-table-column
              label="MAC Address"
              prop="mac"
              header-align="center">
            </el-table-column>

            <el-table-column 
              label="Operations"
              header-align="center">
                <template slot-scope="props">
                  <span v-if="props.row.zigbee">
                    <el-tooltip class="op-tooltip" effect="dark" content="Turn off" placement="top" :enterable="false">
                      <el-button class="ui icon button light-btn" @click="flashLights(props.row)">
                        <i class="el-icon-fa-lightbulb-o"></i>
                      </el-button>
                    </el-tooltip>
                  </span>

                  <span v-if="showSave(props.row)">
                    <el-tooltip class="op-tooltip" effect="dark" content="Save to this field" placement="top" :enterable="false">
                      <el-button class="ui icon button confirm-btn" @click="saveToField(props.row)">
                        <i class="el-icon-fa-floppy-o"></i>
                      </el-button>
                    </el-tooltip>
                  </span>
                  
                  <span>
                    <el-tooltip class="op-tooltip" effect="dark" content="Change field" placement="top" :enterable="false">
                      <el-button class="ui icon button more-btn" @click="showChangeField(props.row)">
                        <i class="el-icon-arrow-right"></i>
                      </el-button>
                    </el-tooltip>
                  </span>
                </template>
            </el-table-column>

          </el-table>

      </div>

  </div>
</template>

<script>
  import requests from '../../../requests';
  import changeFieldModal from './ChangeFieldModal';

  export default {
    name: 'admin-lights',
    data () {
      return {
        pageName: 'Lights Admin',
        fieldName: '',
        clientId: 0,
        siteId: 0,
        id: 0,
        lights: [],
        savedLights: [],
        allLights: [],
        zigbees: [],
        nodes: [],
        nodesScanning: [],
        showChangeFieldModal: false,
        lightToChange: null,
      }
    },
    beforeMount(){

      this.clientId = this.$route.params.clientId;
      this.siteId = this.$route.params.siteId;
      this.id = this.$route.params.id;

      var context = this;
      requests.getField(this, context.id, function (result) {
        context.fieldName = result.data.field_name;
      });

      requests.getLightsAtField(this, context.id, function (result) {
        context.lights = result.data || [];
        context.savedLights = context.lights.slice();
      })

      requests.getZigbeesAtSite(this, this.siteId, function(result) {
        context.zigbees = result.data || [];
      })

      requests.getLights(this, function(result) {
        context.allLights = result.data || [];
      })

    },
    methods: {
      makeLightsFromNodes(ip, port) {
        this.lights = this.lights.concat(
          this.nodes.map(v => {
            //Attach zigbee to lights if already in db
            var oldLights = this.lights.filter(l => l.mac == v);
            if(oldLights.length){
              oldLights.map(v => {
                v.zigbee = {ip, port}
              })
              return
            }
            
            return {
              field_id: -1,
              id: -1,
              mac: v,
              num: -1,
              zigbee: {ip, port}
            }
          }).filter(v => !!v)
        )
        this.nodes = []
      },
      flashLights(row) {
        if(!row.zigbee) return;

        if(typeof row.zigbee != 'object') {
          var z = row.zigbee.split(':');
          row.zigbee = {ip: z[0], port: z[1]};
        }
        
        var data = {
          ip: row.zigbee.ip,
          port: row.zigbee.port,
          mac: row.mac
        }

        requests.turnZigbeeOn(this, data, function(result) {
          console.log(result)
        })

        // requests.flashLightForSeconds(this, data, function(result) {
        //   console.log(result)
        // })

      },
      showChangeField(row){
        this.lightToChange = row;
        this.showChangeFieldModal = true;
      },
      saveToField(light) {
        light.field_id = this.id;
        
        this.newLight(light);
      },
      updateLight(light) {
        var context = this;
        light.zigbee = this.formatZigbee(light.zigbee);
        this.getLightNum(light).then((num) => {
          light.num = num;

          requests.updateLight(this, light.id, light, function(result) {
            console.log(result);
            if(result.action == 'success') {
              context.refreshTable(light);    
            } else {
              context.$message({
                showClose: true,
                type: 'error',
                message: "Couldn't update. " + result.msg
              })
            }
          })  
        });
      },
      newLight(light) {
        var context = this;        
        light.zigbee = this.formatZigbee(light.zigbee);

        this.getLightNum(light).then((num) => {
          light.num = num;

          requests.newLight(this, light, function(result) {
            console.log(result);
            if(result.action == 'success') {
              context.refreshTable(light);
            } else {
              context.$message({
                showClose: true,
                type: 'error',
                message: "Couldn't update. " + result.msg
              })
            }
          })
        })
      },
      formatZigbee(zigbee) {
        if(!zigbee) return;

        if(typeof zigbee == 'object') {
          return `${zigbee.ip}:${zigbee.port}`
        }

        return zigbee; //already formatted
      },
      getLightNum(light) {
        return new Promise((resolve, reject) => {
          if(light.field_id == this.id && light.num > 0) resolve(light.num); 
          
          var getLights = new Promise((resolve, reject) => {
            if(light.field_id == this.id) {
              resolve(this.lights);
            } else {
              requests.getLightsAtField(this, light.field_id, function(result) {
                resolve(result.data);
              })
            }
          })

          getLights.then((lights) => {
            if(lights && lights.length) {
              var lightNum = Math.max(...lights.map(o => o.num), null);

              if(!lightNum) {
                resolve(lights.length + 1);
              }

              resolve(lightNum + 1);
            } 
            resolve(1);
          })
        })
      },
      manualAdd() {
        
      },
      nodeScan(){
        var context = this;

        if (this.zigbees) {
          Object.values(this.zigbees).map(z => {
            context.nodesScanning.push(`${z.ip}:${z.port}`);
            var ip = z.ip.replace(/https?:\/\//, '')

            requests.getZigbeeNodes(context, ip, z.port, function(result) {

              if(result.action != 'fail') {
                context.nodes = result.data;
                var amount = context.nodes.length;
                var alreadyInDB = context.allLights.filter(v => context.nodes.indexOf(v.mac) > -1);
                context.nodes = context.nodes.filter(m => !context.allLights.filter(v => m == v.mac).length);

                var msg = `${amount} node${amount>1 ? 's':''} returned from ${z.ip}:${z.port}.`

                if(alreadyInDB.length) {
                  msg += ` ${alreadyInDB.length} already assigned and skipped.`;
                }

                context.$message({
                  'showClose': true,
                  'type': 'success',
                  'message': msg
                })
                context.makeLightsFromNodes(ip, z.port);

              } else {

                if(typeof result.msg == 'string' && result.msg.indexOf('ECONNREFUSED') > -1) {
                  context.$message({
                    'showClose': true,
                    'type': 'error',
                    'message': `Zigbee at ${z.ip}:${z.port} is not responding.`,
                  })
                } else {
                  context.$message({
                    'showClose': true,
                    'type': 'error',
                    'message': result.msg || result.data.msg
                  })
                }

              }
              context.nodesScanning.splice(context.nodesScanning.indexOf(`${z.ip}:${z.port}`), 1);              
            })
          })
        }
      },
      refreshTable(updated){
        var context = this;
        requests.getLights(this, function(result) {
          context.allLights = result.data;
        })

        this.showChangeFieldModal = false;
        if(this.id != updated.field_id) {
          this.lights = this.lights.filter(v => v.mac != updated.mac)
        } else {
          this.lights = this.lights.map(v => {
            if(v.mac == updated.mac) 
              return updated; 
            return v;
          })
        }
      },
      showSave(row) {
        return row.num <= -1;
      }
    },
    computed: {
      nodeScanLoading: function() {
        return !!this.nodesScanning.length
      }
    },
    components: {
      'changefieldmodal': changeFieldModal
    }
  }
</script>

<style scoped>
  .btn-wrapper {
    width: unset;
  }
</style>


<style>

  .lights {
    display: block;
    padding: 15pt;
    background-color: white;
  }


</style>


// WEBPACK FOOTER //
// Lights.vue?f4cb49e0